import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { Box, Card, CardContent, CardHeader, CircularProgress, Stack, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import { hexToRgbString } from "../../Utils/Helpers/cssUtils";
import ErrorIcon from "@mui/icons-material/Error";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckIcon from "@mui/icons-material/Check";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
export interface LoadingTimeline {
  asset: DbAssetObjectInfos | undefined | null;
  availableTtmlFiles: any[];
  videoAsset: DbAssetObjectInfos | null;
  videoProxy: any;
  subtitlesData: any;
  setLoading: any;
  errors: any[];
  mode: "unknown" | "stp" | "sub" | "project";
  captions: any[];
}

// const baseTimeline = (icon: React.ReactElement, text: string, color, subtext?: string, position?: "first" | "last") => (
//   <TimelineItem>
//     <TimelineSeparator>
//       {(position === undefined || position === "last") && <TimelineConnector />}
//       <TimelineDot>{icon}</TimelineDot>
//       {(position === undefined || position === "first") && <TimelineConnector />}
//     </TimelineSeparator>
//     <TimelineContent sx={{ py: "12px", px: 2 }}>
//       <Typography lineHeight={subtext ? "auto" : "48px"} color={color} variant="h6" component="span">
//         {text}
//       </Typography>
//       {subtext && <Typography fontSize={"10px"}>{subtext}</Typography>}
//     </TimelineContent>
//   </TimelineItem>
// );

// const timelinePending = (text: string, position?: "first" | "last") =>
//   baseTimeline(<PendingIcon />, text, "text.tier", undefined, position);

// const timelineLoading = (text: string, position?: "first" | "last") =>
//   baseTimeline(<CircularProgress size={"18px"} />, text, "default", undefined, position);

// const timelineDone = (text: string, subText: string, position?: "first" | "last") =>
//   baseTimeline(<CheckCircleIcon color="success" />, text, "text.tier", subText, position);

// const timelineError = (text: string, subText: string, position?: "first" | "last") =>
//   baseTimeline(<ErrorIcon color="error" />, text, "error", subText, position);

export const LoadingTimeline: React.FC<LoadingTimeline> = (props) => {
  const { t } = useTranslation();
  const { asset, availableTtmlFiles, subtitlesData, videoAsset, videoProxy, setLoading, errors, mode, captions } =
    props;

  const theme = useTheme();
  const navigate = useNavigate();
  const [currentState, setCurrenState] = React.useState<any>({
    text: t("page:timelineLoading.text.loadingAsset"),
    type: "pending",
  });

  React.useEffect(() => {
    errors.length > 0 &&
      setCurrenState({ text: t("page:timelineError.text.problemHasBeenEncountered"), type: "error" });
  }, [errors]);

  React.useEffect(() => {
    asset &&
      errors.length === 0 &&
      setCurrenState({
        text:
          mode === "sub"
            ? t("page:body.getAssociatedTtmlFiles")
            : mode === "project"
            ? t("page:body.getAssociatedVttFiles")
            : t("page:body.getSubtitlesMetadata"),
        type: "pending",
      });
  }, [asset, errors.length]);

  //   const renderAsset = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "asset") >= 0) {
  //       return timelineError("Asset", errors[errors.findIndex((x) => x.step === "asset")].message, "first");
  //     }
  //     if (!asset) return timelineLoading("Loading asset", "first");
  //     return timelineDone("Asset loaded", asset.name, "first");
  //   }, [asset, errors.length]);

  React.useEffect(() => {
    availableTtmlFiles.length > 0 &&
      errors.length === 0 &&
      setCurrenState({ text: t("page:body.requestingSubtitlesData"), type: "pending" });
  }, [availableTtmlFiles, errors.length]);

  //   const renderTtmlFile = React.useMemo(() => {
  //     if (!asset && !subtitlesData) return timelinePending("Ttml/Vtt files");
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "ttmlFile") >= 0) {
  //       return timelineError("Ttml/Vtt files", errors[errors.findIndex((x) => x.step === "ttmlFile")].message);
  //     }
  //     if (availableTtmlFiles.length === 0) return timelineLoading("Get ttml/vtt files");

  //     return timelineDone("Ttml/Vtt files found", `Count : ${availableTtmlFiles.length}`);
  //   }, [asset, availableTtmlFiles, subtitlesData, errors.length]);

  React.useEffect(() => {
    subtitlesData &&
      mode === "sub" &&
      errors.length === 0 &&
      setCurrenState({
        text: mode === "sub" ? t("page:body.requestingVideoAssetReference") : t("page:body.parsingSubtitlesMetadata"),
        type: "pending",
      });
  }, [subtitlesData, errors.length]);

  //   const renderSubtitlesData = React.useMemo(() => {
  //     if (availableTtmlFiles.length === 0 && !subtitlesData) return timelinePending("Subtitles data");
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "subtitlesData") >= 0) {
  //       return timelineError("Subtitles data", errors[errors.findIndex((x) => x.step === "subtitlesData")].message);
  //     }
  //     if (!subtitlesData) return timelineLoading("Get subtitles data");

  //     if (mode === "sub" || mode === "project")
  //       return timelineDone(
  //         "Subtitles data found",
  //         `Row count : ${subtitlesData.rows ? subtitlesData.rows?.length : "Unknown"}`
  //       );
  //     else return timelineDone("Subtitles data found", `speakers : ${subtitlesData.speech.speaker?.length}`);
  //   }, [subtitlesData, availableTtmlFiles, errors.length]);

  React.useEffect(() => {
    captions.length > 0 &&
      !videoProxy &&
      errors.length === 0 &&
      setCurrenState({ text: t("page:loadingTimeline.requestingVideoProxy"), type: "pending" });
  }, [captions, videoProxy, errors.length]);

  //   const renderParsedCaptions = React.useMemo(() => {
  //     if (!subtitlesData) return timelinePending("Parsing data");
  //     if (captions.length === 0) return timelineLoading("Parsing subtitles");
  //     return timelineDone("Subtitles metadata parsed", `row count : ${captions.length}`);
  //   }, [captions, subtitlesData, errors.length]);

  React.useEffect(() => {
    videoAsset &&
      mode === "sub" &&
      errors.length === 0 &&
      setCurrenState({ text: t("page:loadingTimeline.requestingVideoProxy"), type: "pending" });
  }, [videoAsset, errors.length]);

  //   const renderVideoAsset = React.useMemo(() => {
  //     if (!subtitlesData) return timelinePending("Video asset");
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "videoAsset") >= 0) {
  //       return timelineError("Video asset", errors[errors.findIndex((x) => x.step === "videoAsset")].message);
  //     }
  //     if (!videoAsset) return timelineLoading("Loading video asset");

  //     return timelineDone("Video asset Loaded", videoAsset.name);
  //   }, [videoAsset, subtitlesData, errors.length]);

  React.useEffect(() => {
    videoProxy &&
      errors.length === 0 &&
      setCurrenState({ text: t("page:loadingTimeline.readyWithDot"), type: "success" });
  }, [videoProxy, videoAsset, errors.length]);

  //   const renderVideoProxy = React.useMemo(() => {
  //     if ((!videoAsset && mode !== "project") || !subtitlesData) return timelinePending("Video Proxy", "last");
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "videoProxy") >= 0) {
  //       return timelineError("Video proxy", errors[errors.findIndex((x) => x.step === "videoProxy")].message, "last");
  //     }
  //     if (!videoProxy) return timelineLoading("Search for video proxy", "last");

  //     return timelineDone("Video Proxy found", videoProxy.name, "last");
  //   }, [videoAsset, videoProxy, errors.length, subtitlesData]);

  React.useEffect(() => {
    if (videoProxy) {
      setTimeout(() => {
        setLoading(false);
      }, 200);
    }
  }, [videoProxy]);

  //   React.useEffect(() => {
  //     if (errors.length > 0) {
  //       setTimeout(() => {
  //         navigate(-1);
  //       }, 3000);
  //     }
  //   }, [errors.length]);

  //   const renderCurrentState = React.useMemo(() => {
  //     return (
  //       <Stack
  //         sx={{
  //           backgroundColor: theme.palette.background.paper,
  //           border: `1px solid ${theme.palette.background.default}`,
  //           borderRadius: "6px",
  //         }}
  //         display={"flex"}
  //         justifyContent={"center"}
  //         alignContent={"center"}
  //         alignItems={"center"}
  //         height={"118px"}
  //         width={"300px"}
  //         spacing={2}
  //       >
  //         {currentState.type === "pending" && <CircularProgress size="45px" />}
  //         {currentState.type === "error" && <ErrorIcon color="error" fontSize="large" />}
  //         {currentState.type === "success" && <CheckCircleIcon color="success" fontSize="large" />}
  //         <Typography variant="h6">{currentState.text}</Typography>
  //       </Stack>
  //     );
  //   }, [currentState.text]);

  //   const errorObject = (text: string, error: string) => (
  //     <Card
  //       sx={{
  //         p: "3px 6px 6px 6px !important",
  //         backgroundColor: theme.palette.background.paper,

  //         position: "relative",
  //         scale: 0.6,
  //         border: `1px solid ${theme.palette.background.default}`,
  //       }}
  //       raised
  //     >
  //       <CardHeader
  //         sx={{ color: theme.palette.error.main, p: "3px 3px 3px 3px !important", mb: "0px !important" }}
  //         title={text}
  //       />
  //       <ErrorOutlineIcon color="error" sx={{ position: "absolute", top: "12px", right: "12px" }} />
  //       <CardContent sx={{ p: "3px 3px 3px 3px !important" }}>
  //         <Typography color={theme.palette.error.main} variant="body1">
  //           {error}
  //         </Typography>
  //       </CardContent>
  //     </Card>
  //   );

  //   const missingObject = (text: string) => (
  //     <Card
  //       sx={{
  //         p: "3px 6px 6px 6px !important",
  //         backgroundColor: theme.palette.background.paper,

  //         position: "relative",
  //         scale: 0.6,
  //         border: `1px solid ${theme.palette.background.default}`,
  //       }}
  //       raised
  //     >
  //       <CardHeader sx={{ p: "3px 3px 3px 3px !important", mb: "0px !important" }} title={text} />
  //       <CheckBoxOutlineBlankIcon sx={{ position: "absolute", top: "12px", right: "12px" }} />
  //       <CardContent sx={{ p: "3px 3px 3px 3px !important" }}>
  //         <Typography color="text.tier" variant="body1">
  //           Not loaded yet
  //         </Typography>
  //       </CardContent>
  //     </Card>
  //   );

  //   const foundObject = (title: string, subTitle: string, textList?: (string | null)[]) => (
  //     <Card
  //       sx={{
  //         p: "3px 6px 6px 6px !important",
  //         backgroundColor: theme.palette.background.paper,

  //         position: "relative",
  //         scale: 0.6,
  //         border: `1px solid ${theme.palette.background.default}`,
  //       }}
  //       raised
  //     >
  //       <CardHeader sx={{ p: "3px 3px 3px 3px !important", mb: "0px !important" }} title={title} />
  //       <CheckIcon sx={{ position: "absolute", top: "9px", right: "9px" }} />
  //       <CardContent
  //         sx={{ p: "3px 3px 3px 3px !important", display: "flex", flexDirection: "column", mb: "0px !important" }}
  //       >
  //         <Typography
  //           sx={{
  //             mb: 1,
  //             display: "block",
  //             textOverflow: "ellipsis",
  //             wordWrap: "break-word",
  //             overflow: "hidden",
  //             maxHeight: "28px",
  //             lineHeight: "14px",
  //           }}
  //           color="text.tier"
  //           variant="h6"
  //         >
  //           {subTitle}
  //         </Typography>
  //         {textList &&
  //           textList
  //             .filter((x) => x !== null)
  //             .map((x, i) => (
  //               <Typography
  //                 sx={{
  //                   display: "block",
  //                   textOverflow: "ellipsis",
  //                   wordWrap: "break-word",
  //                   overflow: "hidden",
  //                   maxHeight: "12px",
  //                   lineHeight: "12px",
  //                   mb: i === textList.filter((x) => x !== null).length - 1 ? 0 : 1,
  //                 }}
  //                 color="text.tier"
  //                 variant="body2"
  //               >
  //                 {x}
  //               </Typography>
  //             ))}
  //       </CardContent>
  //     </Card>
  //   );

  //   const renderLoadedAsset = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "asset") >= 0) {
  //       return errorObject("Asset", errors[errors.findIndex((x) => x.step === "asset")].message);
  //     }
  //     if (!asset) return missingObject("Asset");
  //     return foundObject("Asset", asset.name, [asset.type + " - " + asset.status + " - " + asset.classification]);
  //   }, [asset, errors.length]);

  //   const renderLoadedTtmlFiles = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "ttmlFile") >= 0) {
  //       return errorObject("Ttml/Vtt files", errors[errors.findIndex((x) => x.step === "ttmlFile")].message);
  //     }
  //     if (availableTtmlFiles.length === 0) return missingObject("Ttml/Vtt files");
  //     return foundObject(
  //       "Ttml/Vtt files",
  //       `found ${availableTtmlFiles.length} ttml/vtt files`,
  //       availableTtmlFiles.map((x) => x.name)
  //     );
  //   }, [availableTtmlFiles, errors.length]);

  //   const renderLoadedSubtitlesData = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "subtitlesData") >= 0) {
  //       return errorObject("Subtitles data", errors[errors.findIndex((x) => x.step === "subtitlesData")].message);
  //     }
  //     if (!subtitlesData) return missingObject("Subtitles");
  //     return foundObject("Subtitles", `found subtitle with ${subtitlesData.rows?.length} rows`);
  //   }, [subtitlesData, errors.length]);

  //   const renderParsedCaptionsData = React.useMemo(() => {
  //     if (captions.length === 0) return missingObject("Parsed subtitles metadata");
  //     return foundObject("Parsed subtitles metadata", `Parse subtitles with ${captions.length} rows`);
  //   }, [captions]);

  //   const renderLoadedVideoAsset = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "videoAsset") >= 0) {
  //       return errorObject("Video asset", errors[errors.findIndex((x) => x.step === "videoAsset")].message);
  //     }
  //     if (!videoAsset) return missingObject("Video Asset");
  //     return foundObject("Video Asset", videoAsset.name, [
  //       videoAsset.type + " - " + videoAsset.status + " - " + videoAsset.classification,
  //     ]);
  //   }, [videoAsset, errors.length]);

  //   const renderLoadedVideoProxy = React.useMemo(() => {
  //     if (errors.length > 0 && errors.findIndex((x) => x.step === "videoProxy") >= 0) {
  //       return errorObject("Video proxy", errors[errors.findIndex((x) => x.step === "videoProxy")].message);
  //     }
  //     if (!videoProxy) return missingObject("Video Proxy");
  //     return foundObject("Video Proxy", videoProxy.name, [videoProxy.extension + " - " + videoProxy.fullPath]);
  //   }, [videoProxy, errors.length]);

  return (
    <Box
      position={"absolute"}
      top={0}
      left={0}
      right={0}
      bottom={0}
      sx={{
        backdropFilter: "blur(10px)",
        opacity: 1,
        background: `linear-gradient(180deg, rgba(${hexToRgbString(
          theme.palette.background.default
        )}, 0) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0.40) 38.24%, ${
          theme.palette.background.default
        } 88.03%), radial-gradient(237.49% 141.42% at 100.00% -0.00%, rgba(${hexToRgbString(
          theme.palette.background.default
        )}, 0.00) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0.00) 45.17%, rgba(${hexToRgbString(
          theme.palette.background.default
        )}, 0.50) 59.44%, ${theme.palette.background.default} 72.80%)`,
      }}
      zIndex={2000}
      overflow={"hidden"}
      display={"flex"}
      justifyContent={"center"}
      flexDirection={"row"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  );
  //   return (
  //     <Box
  //       position={"absolute"}
  //       top={0}
  //       left={0}
  //       right={0}
  //       bottom={0}
  //       sx={{
  //         backdropFilter: "blur(10px)",
  //         opacity: 1,
  //         background: `linear-gradient(180deg, rgba(${hexToRgbString(
  //           theme.palette.background.default
  //         )}, 0) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0.40) 38.24%, ${
  //           theme.palette.background.default
  //         } 88.03%), radial-gradient(237.49% 141.42% at 100.00% -0.00%, rgba(${hexToRgbString(
  //           theme.palette.background.default
  //         )}, 0.00) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0.00) 45.17%, rgba(${hexToRgbString(
  //           theme.palette.background.default
  //         )}, 0.50) 59.44%, ${theme.palette.background.default} 72.80%)`,
  //       }}
  //       zIndex={2000}
  //       overflow={"hidden"}
  //       display={"flex"}
  //       justifyContent={"center"}
  //       flexDirection={"row"}
  //     >
  //       <Box
  //         flexDirection={"column"}
  //         maxHeight={"769px"}
  //         maxWidth={"1024px"}
  //         display={"flex"}
  //         alignContent={"center"}
  //         alignItems={"center"}
  //       >
  //         <Typography
  //           color={errors.length === 0 ? "inherit" : theme.palette.warning.main}
  //           sx={{ width: "100%", position: "relative", top: "38px", pl: 1 }}
  //           variant="h3"
  //         >
  //           {errors.length === 0 ? "Scribetool is loading..." : "Error while loading scribetool"}
  //         </Typography>
  //         <Stack mt={9} display={"flex"} direction={"row"} width={"100%"} spacing={4}>
  //           <Stack width={"300px"} spacing={1} display={"flex"} direction={"column"}>
  //             <Stack display={"flex"} flexDirection={"column"} borderRadius={"15px"} spacing={1} width={"300px"}>
  //               {renderLoadedAsset}
  //               {(mode === "sub" || mode === "project") && renderLoadedTtmlFiles}
  //               {renderLoadedSubtitlesData}
  //               {mode === "stp" && renderParsedCaptionsData}
  //               {mode === "sub" && renderLoadedVideoAsset}
  //               {renderLoadedVideoProxy}
  //             </Stack>
  //             {renderCurrentState}
  //           </Stack>
  //           <Box
  //             display={"flex"}
  //             justifyContent={"center"}
  //             alignContent={"center"}
  //             alignItems={"center"}
  //             borderRadius={"15px"}
  //             border={`1px solid ${theme.palette.background.paper}`}
  //             sx={{ backgroundColor: theme.palette.background.default }}
  //             p={2}
  //             width={"670px"}
  //             minHeight={"532px"}
  //             position={"relative"}
  //           >
  //             <Box top={"42px"} left={"36px"} display={"flex"} flexDirection={"row"} position={"absolute"}>
  //               <Typography sx={{ mr: 3 }} lineHeight={"36px"} variant="h3">
  //                 Mode :
  //               </Typography>
  //               <Typography
  //                 lineHeight={"36px"}
  //                 color={
  //                   mode === "unknown"
  //                     ? theme.palette.warning.main
  //                     : mode === "stp"
  //                     ? theme.palette.primary.main
  //                     : mode === "project"
  //                     ? theme.palette.info.main
  //                     : theme.palette.success.main
  //                 }
  //                 variant="h3"
  //               >
  //                 {mode === "stp"
  //                   ? "Speech to Text"
  //                   : mode === "sub"
  //                   ? "Subtitles"
  //                   : mode === "project"
  //                   ? "Subtitle Project"
  //                   : "Unknown"}
  //               </Typography>
  //             </Box>
  //             {/* <Timeline
  //               sx={{
  //                 [`& .${timelineItemClasses.root}:before`]: {
  //                   flex: 0,
  //                   padding: 0,
  //                 },
  //                 backgroundColor: theme.palette.background.paper,
  //                 borderRadius: "12px",
  //               }}
  //               position="right"
  //             >
  //               {renderAsset}
  //               {(mode === "sub" || mode === "project") && renderTtmlFile}
  //               {renderSubtitlesData}
  //               {mode === "stp" && renderParsedCaptions}
  //               {mode === "sub" && renderVideoAsset}
  //               {renderVideoProxy}
  //             </Timeline> */}
  //             <Box
  //               width={"300px"}
  //               bottom={0}
  //               left={"169px"}
  //               display={"flex"}
  //               flexDirection={"row"}
  //               justifyContent={"center"}
  //               alignContent={"center"}
  //               alignItems={"center"}
  //               height={"102px"}
  //               position={"absolute"}
  //             >
  //               {currentState.type !== "success" ? (
  //                 errors.length === 0 ? (
  //                   <Typography variant="h5" color={"text.tier"}>
  //                     Please wait...
  //                   </Typography>
  //                 ) : (
  //                   <Typography variant="body1" color={"text.tier"}>
  //                     You will be redirect in few seconds...
  //                   </Typography>
  //                 )
  //               ) : (
  //                 <Typography color={"text.tier"} variant="h3">
  //                   Loading view...
  //                 </Typography>
  //               )}
  //             </Box>
  //           </Box>
  //         </Stack>
  //       </Box>
  //     </Box>
  //   );
};
